
import { eventLog, eventError } from "../lib/log"
import Honeybadger from "@honeybadger-io/js"

eventLog("turbo:click")
eventLog("turbo:before-visit")
eventLog("turbo:visit")
eventLog("turbo:request-start")
eventLog("turbo:request-end")
eventLog("turbo:before-cache")
eventLog("turbo:before-render")
eventLog("turbo:render")
eventLog("turbo:load")
eventError("turbo:frame-missing")

// Removed 2026-05 (see 0476c31ed) — an old browser tab loaded before that
// deploy can still hold a lazy turbo-frame pointed at this dead route.
// The 404 is correct; it's not worth alerting on.
const REMOVED_FRAME_PATH = /\/organizations\/[^/]+\/schedule_strategy_session$/

document.addEventListener("turbo:frame-missing", event => {
  // Redirected responses (e.g., session expiry) are handled with
  // retry logic in turbo_frame_retry.js
  if (event.detail.response.redirected) return
  // 5xx frame loads are retried in turbo_frame_retry.js, which reports only
  // once the retries are exhausted. Server-side errors also land in the
  // backend project, so there's nothing extra to learn from a notice here.
  if (event.detail.response.status >= 500) return
  if (REMOVED_FRAME_PATH.test(new URL(event.detail.response.url, window.location.origin).pathname)) return

  Honeybadger.notify({
    message: "Turbo frame missing",
    name: "turbo:frame-missing",
    context: {
      "targetId": event.target.id,
      "targetSource": event.target.src,
      "responseUrl": event.detail.response.url,
      "responseRedirected": event.detail.response.redirected,
      "responseStatus": event.detail.response.status,
      "targetOuterText": event.target.outerText,
      "targetOuterHTML": event.target.outerHTML
    }
  })
})